import { EventEmitter, Component, Input, Output, ViewChild, NgModule } from '@angular/core';
import { ResponsiveService, B2CSharedResponsiveModule } from 'b2c-ui/core';
import { tap, takeUntil } from 'rxjs/operators';
import { Subject } from 'rxjs';
import { I18nTransKey, I18nModule } from 'b2c-ui/i18n';
import { CommonModule } from '@angular/common';
import { B2CNgzIconModule } from 'b2c-ui/ngz-icons';
import { NzPopoverModule } from 'ng-zorro-antd/popover';
import { FacebookIcon, TwitterIcon, WhatsappIcon, B2cUiIconModule, B2CUiIconService } from 'b2c-ui-icon';
import { NzButtonModule } from 'ng-zorro-antd/button';

/**
 * @fileoverview added by tsickle
 * Generated from: b2c-share.component.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * ##### Import this component individually to your module
 * `import { B2CShareModule } from 'b2c-ui/share';`
 */
import * as ɵngcc0 from '@angular/core';
import * as ɵngcc1 from 'b2c-ui/core';
import * as ɵngcc2 from '@angular/common';
import * as ɵngcc3 from 'ng-zorro-antd/popover';
import * as ɵngcc4 from 'ng-zorro-antd';
import * as ɵngcc5 from 'b2c-ui-icon';
import * as ɵngcc6 from 'b2c-ui/i18n';

const _c0 = ["linkBar"];
function B2CShareComponent_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    const _r8 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵelementStart(1, "button", 4);
    ɵngcc0.ɵɵlistener("click", function B2CShareComponent_ng_container_1_Template_button_click_1_listener() { ɵngcc0.ɵɵrestoreView(_r8); const ctx_r7 = ɵngcc0.ɵɵnextContext(); return ctx_r7.tryShareNatively(); });
    ɵngcc0.ɵɵelement(2, "i", 5);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelement(3, "br");
    ɵngcc0.ɵɵelementStart(4, "span", 6);
    ɵngcc0.ɵɵtext(5);
    ɵngcc0.ɵɵpipe(6, "b2cI18n");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    const _r3 = ɵngcc0.ɵɵreference(5);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("nzPopoverContent", _r3)("nzPopoverTrigger", ctx_r0.nativeSharingAvailable ? "null" : "click");
    ɵngcc0.ɵɵadvance(4);
    ɵngcc0.ɵɵtextInterpolate(ɵngcc0.ɵɵpipeBind1(6, 3, ctx_r0.I18nTransKey == null ? null : ctx_r0.I18nTransKey.SHARE));
} }
function B2CShareComponent_ng_container_2_span_3_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "span", 9);
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵpipe(2, "b2cI18n");
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r9 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate(ɵngcc0.ɵɵpipeBind1(2, 1, ctx_r9.I18nTransKey == null ? null : ctx_r9.I18nTransKey.SHARE));
} }
function B2CShareComponent_ng_container_2_Template(rf, ctx) { if (rf & 1) {
    const _r11 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵelementStart(1, "div", 7);
    ɵngcc0.ɵɵlistener("click", function B2CShareComponent_ng_container_2_Template_div_click_1_listener() { ɵngcc0.ɵɵrestoreView(_r11); const ctx_r10 = ɵngcc0.ɵɵnextContext(); return ctx_r10.tryShareNatively(); });
    ɵngcc0.ɵɵelement(2, "i", 5);
    ɵngcc0.ɵɵtemplate(3, B2CShareComponent_ng_container_2_span_3_Template, 3, 3, "span", 8);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r1 = ɵngcc0.ɵɵnextContext();
    const _r3 = ɵngcc0.ɵɵreference(5);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("nzPopoverContent", _r3)("nzPopoverTrigger", ctx_r1.nativeSharingAvailable ? "null" : "click");
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("ngIf", !ctx_r1.mobileWeb);
} }
function B2CShareComponent_ng_container_3_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainer(0);
} }
function B2CShareComponent_ng_container_3_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵtemplate(1, B2CShareComponent_ng_container_3_ng_container_1_Template, 1, 0, "ng-container", 10);
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    ɵngcc0.ɵɵnextContext();
    const _r3 = ɵngcc0.ɵɵreference(5);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngTemplateOutlet", _r3);
} }
function B2CShareComponent_ng_template_4_ng_container_6_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainer(0);
} }
function B2CShareComponent_ng_template_4_ng_container_7_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainer(0);
} }
function B2CShareComponent_ng_template_4_ng_container_8_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainer(0);
} }
const _c1 = function (a0) { return { url: a0, name: "facebookIcon", text: "Facebook" }; };
const _c2 = function (a0) { return { url: a0, name: "twitterIcon", text: "Twitter" }; };
const _c3 = function (a0) { return { url: a0, name: "whatsappIcon", text: "Whatsapp" }; };
function B2CShareComponent_ng_template_4_Template(rf, ctx) { if (rf & 1) {
    const _r18 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "div", 11);
    ɵngcc0.ɵɵelementStart(1, "div", 12);
    ɵngcc0.ɵɵelementStart(2, "h4", 13);
    ɵngcc0.ɵɵtext(3);
    ɵngcc0.ɵɵpipe(4, "b2cI18n");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(5, "div", 14);
    ɵngcc0.ɵɵtemplate(6, B2CShareComponent_ng_template_4_ng_container_6_Template, 1, 0, "ng-container", 15);
    ɵngcc0.ɵɵtemplate(7, B2CShareComponent_ng_template_4_ng_container_7_Template, 1, 0, "ng-container", 15);
    ɵngcc0.ɵɵtemplate(8, B2CShareComponent_ng_template_4_ng_container_8_Template, 1, 0, "ng-container", 15);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(9, "p", 16);
    ɵngcc0.ɵɵtext(10, "Click to copy link");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(11, "div", 17);
    ɵngcc0.ɵɵelement(12, "input", 18, 19);
    ɵngcc0.ɵɵelement(14, "span", 20);
    ɵngcc0.ɵɵelementStart(15, "span", 21);
    ɵngcc0.ɵɵlistener("click", function B2CShareComponent_ng_template_4_Template_span_click_15_listener() { ɵngcc0.ɵɵrestoreView(_r18); const ctx_r17 = ɵngcc0.ɵɵnextContext(); return ctx_r17.copyFromLinkBar(); });
    ɵngcc0.ɵɵtext(16, "Copy");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r4 = ɵngcc0.ɵɵnextContext();
    const _r5 = ɵngcc0.ɵɵreference(7);
    ɵngcc0.ɵɵadvance(3);
    ɵngcc0.ɵɵtextInterpolate(ɵngcc0.ɵɵpipeBind1(4, 8, ctx_r4.I18nTransKey == null ? null : ctx_r4.I18nTransKey.SHARE));
    ɵngcc0.ɵɵadvance(3);
    ɵngcc0.ɵɵproperty("ngTemplateOutlet", _r5)("ngTemplateOutletContext", ɵngcc0.ɵɵpureFunction1(10, _c1, ctx_r4.facebookUrl));
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngTemplateOutlet", _r5)("ngTemplateOutletContext", ɵngcc0.ɵɵpureFunction1(12, _c2, ctx_r4.twitterUrl));
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngTemplateOutlet", _r5)("ngTemplateOutletContext", ɵngcc0.ɵɵpureFunction1(14, _c3, ctx_r4.whatsappUrl));
    ɵngcc0.ɵɵadvance(4);
    ɵngcc0.ɵɵproperty("value", ctx_r4.link);
} }
function B2CShareComponent_ng_template_6_Template(rf, ctx) { if (rf & 1) {
    const _r23 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "a", 22);
    ɵngcc0.ɵɵlistener("click", function B2CShareComponent_ng_template_6_Template_a_click_0_listener() { ɵngcc0.ɵɵrestoreView(_r23); const name_r20 = ctx.name; const ctx_r22 = ɵngcc0.ɵɵnextContext(); return ctx_r22.emitShareEvent(name_r20 === "Facebook", name_r20 === "Twitter", name_r20 === "Whatsapp", false); });
    ɵngcc0.ɵɵelement(1, "b2c-ui-icon", 23);
    ɵngcc0.ɵɵelementStart(2, "span", 24);
    ɵngcc0.ɵɵtext(3);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const url_r19 = ctx.url;
    const name_r20 = ctx.name;
    const text_r21 = ctx.text;
    ɵngcc0.ɵɵproperty("href", url_r19, ɵngcc0.ɵɵsanitizeUrl);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("name", name_r20);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵtextInterpolate(text_r21);
} }
class B2CShareComponent {
    /**
     * @ignore
     * @param {?} responsiveService
     */
    constructor(responsiveService) {
        this.responsiveService = responsiveService;
        /**
         * link to be shared, default will get window.location.href
         */
        this.link = window.location.href;
        this.mode = B2CSharePlacementEnum.ICON;
        this.shared = new EventEmitter();
        this.B2CSharePlacementEnum = B2CSharePlacementEnum;
        /**
         * @ignore
         */
        this.mobileWeb = false;
        /**
         * @ignore
         */
        this.destroy = new Subject();
        /**
         * @ignore
         */
        this.whatsappUrl = '';
        /**
         * @ignore
         */
        this.twitterUrl = '';
        /**
         * @ignore
         */
        this.facebookUrl = '';
        /**
         * @ignore
         */
        this.nativeSharingAvailable = false;
        /**
         * @ignore
         */
        this.shareClick$ = new Subject();
        /**
         * @ignore
         */
        this.I18nTransKey = I18nTransKey;
    }
    /**
     * @ignore
     * @return {?}
     */
    ngOnInit() {
        /** @type {?} */
        const navi = navigator;
        this.nativeSharingAvailable = !!((navi && navi.share) || false);
        if (this.link) {
            this.prepareShare();
        }
        this.responsiveService
            .isMobileWeb()
            .pipe(tap((/**
         * @param {?} isMobileWeb
         * @return {?}
         */
        (isMobileWeb) => {
            this.mobileWeb = isMobileWeb;
        })), takeUntil(this.destroy))
            .subscribe();
    }
    /**
     * @ignore
     * @param {?} changes
     * @return {?}
     */
    ngOnChanges(changes) {
        /** Twitter: https://developer.twitter.com/en/docs/twitter-for-websites/tweet-button/overview */
        if (changes.link) {
            this.prepareShare();
        }
    }
    /**
     * @ignore
     * @return {?}
     */
    ngOnDestroy() {
        this.destroy.next();
        this.destroy.complete();
    }
    /**
     * @ignore
     * @return {?}
     */
    copyFromLinkBar() {
        if (this.linkBar) {
            /** @type {?} */
            const element = this.linkBar.nativeElement;
            element.focus();
            element.select();
            document.execCommand('copy');
            this.emitShareEvent(false, false, false, true);
        }
    }
    /**
     * @ignore
     * @param {?=} fb
     * @param {?=} tweet
     * @param {?=} wa
     * @param {?=} link
     * @return {?}
     */
    emitShareEvent(fb, tweet, wa, link) {
        /** @type {?} */
        const payload = {
            facebook: false,
            twitter: false,
            whatsapp: false,
            link: false
        };
        if (fb) {
            payload.facebook = true;
        }
        if (tweet) {
            payload.twitter = true;
        }
        if (wa) {
            payload.whatsapp = true;
        }
        if (link) {
            payload.link = true;
        }
        this.shared.emit(payload);
    }
    /**
     * @ignore
     * @return {?}
     */
    tryShareNatively() {
        /**
         * https://web.dev/web-share/
         * @type {?}
         */
        const navi = navigator;
        if (navi.share) {
            navi
                .share({
                title: 'FSMOne',
                url: this.link
            })
                .then((/**
             * @return {?}
             */
            () => {
                this.shared.emit({
                    native: true
                });
            }));
        }
    }
    /**
     * @ignore
     * @return {?}
     */
    prepareShare() {
        if (this.link) {
            /** @type {?} */
            const encodedUrl = encodeURI(this.link);
            this.facebookUrl = `https://www.facebook.com/sharer/sharer.php?u=${encodedUrl}`;
            this.whatsappUrl = `https://wa.me/?text=${encodedUrl}`;
            this.twitterUrl = `https://twitter.com/intent/tweet?url=${encodedUrl}&via=FSMOne_my`;
        }
        else {
            this.whatsappUrl = '';
            this.facebookUrl = '';
            this.twitterUrl = '';
        }
    }
}
B2CShareComponent.ɵfac = function B2CShareComponent_Factory(t) { return new (t || B2CShareComponent)(ɵngcc0.ɵɵdirectiveInject(ɵngcc1.ResponsiveService)); };
B2CShareComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: B2CShareComponent, selectors: [["b2c-share-bar"]], viewQuery: function B2CShareComponent_Query(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵviewQuery(_c0, true);
    } if (rf & 2) {
        var _t;
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.linkBar = _t.first);
    } }, inputs: { link: "link", mode: "mode" }, outputs: { shared: "shared" }, features: [ɵngcc0.ɵɵNgOnChangesFeature], decls: 8, vars: 4, consts: [[3, "ngSwitch"], [4, "ngSwitchCase"], ["shareContentTemplate", ""], ["socialIconTemplate", ""], ["nz-popover", "", "nzPopoverPlacement", "bottomLeft", 1, "b2c-share-comp-button", "ant-btn", "ant-btn-circle", "text-center", "text-primary", "bg-white", 3, "nzPopoverContent", "nzPopoverTrigger", "click"], ["nz-icon", "", "nzType", "share-alt", "nzTheme", "outline", 1, "text-md", "text-primary"], [1, "text-sm", "text-center", "text-primary", "font-weight-bold"], ["nz-popover", "", "nzPopoverPlacement", "topLeft", 1, "pointer", "d-flex", "align-items-start", 3, "nzPopoverContent", "nzPopoverTrigger", "click"], ["class", "ml-2 text-base text-center text-primary font-weight-bold", 4, "ngIf"], [1, "ml-2", "text-base", "text-center", "text-primary", "font-weight-bold"], [4, "ngTemplateOutlet"], [1, "bg-white", "container", "p-3", 2, "max-width", "320px"], [1, "w-100", "d-flex", "justify-content-between", "mb-3"], [1, "text-black-7"], [1, "mb-5"], [4, "ngTemplateOutlet", "ngTemplateOutletContext"], [1, "text-black-7", "mb-2", "text-sm"], [1, "border", "p-2", "d-flex"], ["type", "text", "readonly", "", "aria-readonly", "true", 1, "plain-input-copy-link", "border-0", "flex-grow-1", 2, "user-select", "none", 3, "value"], ["linkBar", ""], [1, "ml-2", "mr-2"], [1, "text-info", "pointer", "font-weight-bold", 2, "user-select", "none", 3, "click"], ["target", "_blank", "rel", "noreferrer noopener", 1, "mb-4", "d-flex", "align-items-center", "pointer", 3, "href", "click"], [1, "mr-2", 3, "name"], [1, "font-weight-bold", "mb-0", "text-base", "text-black"]], template: function B2CShareComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementContainerStart(0, 0);
        ɵngcc0.ɵɵtemplate(1, B2CShareComponent_ng_container_1_Template, 7, 5, "ng-container", 1);
        ɵngcc0.ɵɵtemplate(2, B2CShareComponent_ng_container_2_Template, 4, 3, "ng-container", 1);
        ɵngcc0.ɵɵtemplate(3, B2CShareComponent_ng_container_3_Template, 2, 1, "ng-container", 1);
        ɵngcc0.ɵɵelementContainerEnd();
        ɵngcc0.ɵɵtemplate(4, B2CShareComponent_ng_template_4_Template, 17, 16, "ng-template", null, 2, ɵngcc0.ɵɵtemplateRefExtractor);
        ɵngcc0.ɵɵtemplate(6, B2CShareComponent_ng_template_6_Template, 4, 3, "ng-template", null, 3, ɵngcc0.ɵɵtemplateRefExtractor);
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("ngSwitch", ctx.mode);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngSwitchCase", ctx.B2CSharePlacementEnum.CIRCULAR);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngSwitchCase", ctx.B2CSharePlacementEnum.ICON);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngSwitchCase", ctx.B2CSharePlacementEnum.TEMPLATE);
    } }, directives: [ɵngcc2.NgSwitch, ɵngcc2.NgSwitchCase, ɵngcc3.NzPopoverDirective, ɵngcc4.NzIconDirective, ɵngcc2.NgIf, ɵngcc2.NgTemplateOutlet, ɵngcc5.B2CUiIconComponent], pipes: [ɵngcc6.B2CI18nPipe], encapsulation: 2 });
/** @nocollapse */
B2CShareComponent.ctorParameters = () => [
    { type: ResponsiveService }
];
B2CShareComponent.propDecorators = {
    link: [{ type: Input }],
    mode: [{ type: Input }],
    shared: [{ type: Output }],
    linkBar: [{ type: ViewChild, args: ['linkBar', { static: false },] }]
};
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(B2CShareComponent, [{
        type: Component,
        args: [{
                selector: 'b2c-share-bar',
                template: "<ng-container [ngSwitch]=\"mode\">\r\n  <ng-container *ngSwitchCase=\"B2CSharePlacementEnum.CIRCULAR\">\r\n    <button nz-popover [nzPopoverContent]=\"shareContentTemplate\" nzPopoverPlacement=\"bottomLeft\" [nzPopoverTrigger]=\"nativeSharingAvailable ? 'null' : 'click'\" (click)=\"tryShareNatively()\"\r\n      class=\"b2c-share-comp-button ant-btn ant-btn-circle text-center text-primary bg-white\">\r\n      <i nz-icon nzType=\"share-alt\" nzTheme=\"outline\" class=\"text-md text-primary\"></i>\r\n    </button>\r\n    <br />\r\n    <span class=\"text-sm text-center text-primary font-weight-bold\">{{ I18nTransKey?.SHARE | b2cI18n }}</span>\r\n  </ng-container>\r\n  <ng-container *ngSwitchCase=\"B2CSharePlacementEnum.ICON\">\r\n    <div class=\"pointer d-flex align-items-start\" nz-popover [nzPopoverContent]=\"shareContentTemplate\" nzPopoverPlacement=\"topLeft\" [nzPopoverTrigger]=\"nativeSharingAvailable ? 'null' : 'click'\" (click)=\"tryShareNatively()\">\r\n      <i nz-icon nzType=\"share-alt\" nzTheme=\"outline\" class=\"text-md text-primary\"></i>\r\n      <span class=\"ml-2 text-base text-center text-primary font-weight-bold\" *ngIf=\"!mobileWeb\">{{ I18nTransKey?.SHARE | b2cI18n }}</span>\r\n    </div>\r\n  </ng-container>\r\n  <ng-container *ngSwitchCase=\"B2CSharePlacementEnum.TEMPLATE\">\r\n    <ng-container *ngTemplateOutlet=\"shareContentTemplate\"></ng-container>\r\n  </ng-container>\r\n</ng-container>\r\n\r\n\r\n<ng-template #shareContentTemplate>\r\n  <div class=\"bg-white container p-3\" style=\"max-width: 320px;\">\r\n    <div class=\"w-100 d-flex justify-content-between mb-3\">\r\n      <h4 class=\"text-black-7\">{{ I18nTransKey?.SHARE | b2cI18n }}</h4>\r\n      <!-- <i nz-icon nzType=\"close\" nzTheme=\"outline\" (click)=\"onClose()\" class=\"pointer\"></i> -->\r\n    </div>\r\n    <div class=\"mb-5\">\r\n      <ng-container *ngTemplateOutlet=\"socialIconTemplate; context: { url: facebookUrl, name: 'facebookIcon', text: 'Facebook' }\"></ng-container>\r\n      <ng-container *ngTemplateOutlet=\"socialIconTemplate; context: { url: twitterUrl, name: 'twitterIcon', text: 'Twitter' }\"></ng-container>\r\n      <ng-container *ngTemplateOutlet=\"socialIconTemplate; context: { url: whatsappUrl, name: 'whatsappIcon', text: 'Whatsapp' }\"></ng-container>\r\n    </div>\r\n    <p class=\"text-black-7 mb-2 text-sm\">Click to copy link</p>\r\n    <div class=\"border p-2 d-flex\">\r\n      <input type=\"text\" [value]=\"link\" class=\"plain-input-copy-link border-0 flex-grow-1\" #linkBar readonly aria-readonly=\"true\" style=\"user-select: none;\">\r\n      <span class=\"ml-2 mr-2\"></span>\r\n      <span class=\"text-info pointer font-weight-bold\" style=\"user-select: none;\" (click)=\"copyFromLinkBar()\">Copy</span>\r\n    </div>\r\n  </div>\r\n</ng-template>\r\n\r\n<ng-template #socialIconTemplate let-url=\"url\" let-name=\"name\" let-text=\"text\">\r\n  <a class=\"mb-4 d-flex align-items-center pointer\" [href]=\"url\" target=\"_blank\" rel=\"noreferrer noopener\" (click)=\"emitShareEvent(name === 'Facebook', name === 'Twitter', name === 'Whatsapp', false)\">\r\n    <b2c-ui-icon [name]=\"name\" class=\"mr-2\"></b2c-ui-icon>\r\n    <span class=\"font-weight-bold mb-0 text-base text-black\">{{ text }}</span>\r\n  </a>\r\n</ng-template>\r\n"
            }]
    }], function () { return [{ type: ɵngcc1.ResponsiveService }]; }, { link: [{
            type: Input
        }], mode: [{
            type: Input
        }], shared: [{
            type: Output
        }], linkBar: [{
            type: ViewChild,
            args: ['linkBar', { static: false }]
        }] }); })();
if (false) {
    /**
     * link to be shared, default will get window.location.href
     * @type {?}
     */
    B2CShareComponent.prototype.link;
    /** @type {?} */
    B2CShareComponent.prototype.mode;
    /** @type {?} */
    B2CShareComponent.prototype.shared;
    /**
     * @ignore
     * @type {?}
     */
    B2CShareComponent.prototype.linkBar;
    /** @type {?} */
    B2CShareComponent.prototype.B2CSharePlacementEnum;
    /**
     * @ignore
     * @type {?}
     */
    B2CShareComponent.prototype.mobileWeb;
    /**
     * @ignore
     * @type {?}
     */
    B2CShareComponent.prototype.destroy;
    /**
     * @ignore
     * @type {?}
     */
    B2CShareComponent.prototype.whatsappUrl;
    /**
     * @ignore
     * @type {?}
     */
    B2CShareComponent.prototype.twitterUrl;
    /**
     * @ignore
     * @type {?}
     */
    B2CShareComponent.prototype.facebookUrl;
    /**
     * @ignore
     * @type {?}
     */
    B2CShareComponent.prototype.nativeSharingAvailable;
    /**
     * @ignore
     * @type {?}
     */
    B2CShareComponent.prototype.shareClick$;
    /**
     * @ignore
     * @type {?}
     */
    B2CShareComponent.prototype.I18nTransKey;
    /**
     * @type {?}
     * @private
     */
    B2CShareComponent.prototype.responsiveService;
}
/** @enum {number} */
const B2CSharePlacementEnum = {
    CIRCULAR: 1,
    ICON: 2,
    TEMPLATE: 3,
};
B2CSharePlacementEnum[B2CSharePlacementEnum.CIRCULAR] = 'CIRCULAR';
B2CSharePlacementEnum[B2CSharePlacementEnum.ICON] = 'ICON';
B2CSharePlacementEnum[B2CSharePlacementEnum.TEMPLATE] = 'TEMPLATE';
/**
 * @record
 */
function B2CShareEvent() { }
if (false) {
    /** @type {?|undefined} */
    B2CShareEvent.prototype.facebook;
    /** @type {?|undefined} */
    B2CShareEvent.prototype.twitter;
    /** @type {?|undefined} */
    B2CShareEvent.prototype.whatsapp;
    /** @type {?|undefined} */
    B2CShareEvent.prototype.link;
    /** @type {?|undefined} */
    B2CShareEvent.prototype.native;
}

/**
 * @fileoverview added by tsickle
 * Generated from: b2c-share.module.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/** @type {?} */
const ICONS = [FacebookIcon, TwitterIcon, WhatsappIcon];
class B2CShareModule {
    /**
     * @param {?} b2cIconService
     */
    constructor(b2cIconService) {
        this.b2cIconService = b2cIconService;
        this.b2cIconService.registerIcons([...ICONS]);
    }
}
B2CShareModule.ɵmod = ɵngcc0.ɵɵdefineNgModule({ type: B2CShareModule });
B2CShareModule.ɵinj = ɵngcc0.ɵɵdefineInjector({ factory: function B2CShareModule_Factory(t) { return new (t || B2CShareModule)(ɵngcc0.ɵɵinject(ɵngcc5.B2CUiIconService)); }, imports: [[
            CommonModule,
            B2CSharedResponsiveModule,
            B2CNgzIconModule,
            B2cUiIconModule,
            NzButtonModule,
            NzPopoverModule,
            I18nModule
        ]] });
/** @nocollapse */
B2CShareModule.ctorParameters = () => [
    { type: B2CUiIconService }
];
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(B2CShareModule, { declarations: function () { return [B2CShareComponent]; }, imports: function () { return [CommonModule,
        B2CSharedResponsiveModule,
        B2CNgzIconModule,
        B2cUiIconModule,
        NzButtonModule,
        NzPopoverModule,
        I18nModule]; }, exports: function () { return [B2CShareComponent]; } }); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(B2CShareModule, [{
        type: NgModule,
        args: [{
                declarations: [B2CShareComponent],
                exports: [B2CShareComponent],
                imports: [
                    CommonModule,
                    B2CSharedResponsiveModule,
                    B2CNgzIconModule,
                    B2cUiIconModule,
                    NzButtonModule,
                    NzPopoverModule,
                    I18nModule
                ]
            }]
    }], function () { return [{ type: ɵngcc5.B2CUiIconService }]; }, null); })();
if (false) {
    /**
     * @type {?}
     * @private
     */
    B2CShareModule.prototype.b2cIconService;
}

/**
 * @fileoverview added by tsickle
 * Generated from: public_api.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */

/**
 * @fileoverview added by tsickle
 * Generated from: b2c-ui-share.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */

export { B2CShareComponent, B2CShareModule, B2CSharePlacementEnum };


//# sourceMappingURL=b2c-ui-share.js.map